import { Formik } from 'formik';
import { useContext } from 'react';
import { ApiKey } from '../../../../../../../../../typings/ApiKey.interface';
import { ApiKeyScopeFormValues, ApiKeyScopesFields, scopesFromScopeValues, scopeValuesFromScopes } from '../../../../../common/ApiKeys/ApiKeyScopesFields';
import { Div } from '../../../../../common/helpers/StyledUtils';
import Modal from '../../../../../common/Modal';
import { useToasts } from '../../../../../common/Toast';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import { DashboardContext } from '../../../DashboardContext';
interface Props {
  api_key: ApiKey;
  // Organization settings update through the organization API, project settings through the
  // project API (open to project admins).
  managed_from: 'organization' | 'project';
  onClose: () => void;
  onApiKeyUpdated: (api_key: ApiKey) => void;
}
const UpdateProjectApiKeyModal: React.FC<Props> = ({
  api_key,
  managed_from,
  onClose,
  onApiKeyUpdated
}) => {
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    team,
    teams
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  const project_0 = teams?.find(project => project.id === api_key.team_id) ?? (team?.id === api_key.team_id ? team : undefined);
  const project_types = project_0 ? [project_0.type] : [];
  const onSubmit = async (values: ApiKeyScopeFormValues) => {
    try {
      const api = managed_from === 'organization' ? HookdeckAPI.organizations : HookdeckAPI.teams;
      const updated_api_key = await api.updateApiKey(api_key.id, {
        scopes: scopesFromScopeValues('project', values, project_types)
      });
      onApiKeyUpdated(updated_api_key);
      addToast('success', 'API key updated');
      onClose();
    } catch (err) {
      addToast('error', err.message);
    }
  };
  return <Formik<ApiKeyScopeFormValues> initialValues={scopeValuesFromScopes('project', api_key.scopes ?? ['*'], project_types)} onSubmit={onSubmit}>
      {props => <form onSubmit={props.handleSubmit}>
          <Modal title={`Update ${api_key.label ?? 'Untitled'} API key`} submit_label="Update API key" cancel_label="Cancel" hide_close onSubmit={props.handleSubmit} onCancel={onClose} onClose={onClose} is_submitting={props.isSubmitting} submit_disabled={!props.isValid}>
            <Div flex={{
          direction: 'column',
          gap: 4
        }}>
              <ApiKeyScopesFields tier="project" project_types={project_types} />
            </Div>
          </Modal>
        </form>}
    </Formik>;
};
export default UpdateProjectApiKeyModal;